import { closeGallery, selectPicture, nextPicture, previousPicture, galleryShown } from './actions';

export default {
    closeGallery,
    selectPicture,
    nextPicture,
    previousPicture,
    galleryShown,
};

